import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PortalConfigContext } from '../../../context';
import { useMessagingSettingsForm } from './useMessagingSettingsForm';
import {
  MessageSettings,
  ModuleSettingsItem,
} from '../../../constants/dataTypes';
import { listUsers } from '../../../store/users/actions';
import { RootState } from '../../../store';
import { saveMessageSettings } from '../../../store/settings/actions';
import { SettingsPageForm } from '../SettingsPageForm';
import { ModuleContainer } from '../ModuleContainer';
import { SetupModulePageDescription } from '../ModuleManagementPage/SetupModule';
import SetupModuleBreadCrumbs from '../ModuleManagementPage/SetupModule/SetupModuleBreadCrumbs';
import { useEditingModule } from '../ModuleManagementPage/SetupModule/useEditingModule';
import history from '../../../history';
import { MODULE_MANAGEMENT_PAGE } from '../../../constants';

const MessagingPage = () => {
  const portalConfig = React.useContext(PortalConfigContext);
  const dispatch = useDispatch();
  const { loadedUsers, isLoading: isUsersLoading } = useSelector(
    (state: RootState) => state.users,
  );
  const messagesModule = useEditingModule();
  const messageSettings = useSelector(
    (state: RootState) => state.settings.messageSettings,
  );

  const initialValues = {
    label: messagesModule?.label || '',
    icon: messagesModule?.icon || '',
    fields: {
      messageBody:
        (messageSettings && messageSettings.fields.messageBody) ||
        `Welcome to the ${portalConfig.name} portal.`,
    },
  };

  const onSave = async (values: MessageSettings & ModuleSettingsItem) => {
    const newMessageSettings = {
      ...messageSettings,
      label: values?.label,
      icon: values?.icon,
      fields: {
        ...values.fields,
      },
    };
    await dispatch(
      saveMessageSettings({
        messageSettings: newMessageSettings,
        currentMessagesModule: messagesModule,
      }),
    );
    history.push(MODULE_MANAGEMENT_PAGE.path);
  };

  React.useEffect(() => {
    if (!loadedUsers && !isUsersLoading) {
      dispatch(listUsers(false));
    }
  }, []);

  return loadedUsers ? (
    <ModuleContainer description={<SetupModulePageDescription />}>
      <SettingsPageForm
        BreadcrumbsComponent={<SetupModuleBreadCrumbs />}
        useFormHook={useMessagingSettingsForm}
        initialFormValue={initialValues}
        handleSave={onSave}
        actionLabel={messagesModule?.disabled ? 'Enable' : 'Save'}
        shouldShowPageAction={messagesModule?.disabled}
      />
    </ModuleContainer>
  ) : null;
};

export default MessagingPage;
